import { Grid, IconButton, Tooltip } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { HISTORY_TAB } from "app/common/LocalConst";
import { isRoleHisReadOnly } from "app/common/LocalFunction";
import FlowSeriesTimeline from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/GeneralInfomationTab/Component/FlowSeriesTimeline";
import { observer } from "mobx-react";
import { memo } from "react";

const ListCheckInBlock = ({
  initialPatient,
  setCurrentTab,
  handleOpenFormCheckIn,
}) => {
  const isReadonly = isRoleHisReadOnly();

  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid
        container
        spacing={1}
        className="m-0 w-100"
        style={{ backgroundColor: "aliceblue" }}
      >
        <Grid
          item
          sm={12}
          className="search-title-card"
          style={{ width: "100%" }}
        >
          <p className="title-block">Lịch sử check in</p>
          {!isReadonly && (
            <div className="flex align-center flex-end gap-1 cursor">
              <Tooltip title="Check In">
                <IconButton
                  size="small"
                  style={{ color: "#eb7d15" }}
                  onClick={() => {
                    handleOpenFormCheckIn(initialPatient?.patientInfo);
                  }}
                >
                  <Add className="font-md" />
                </IconButton>
              </Tooltip>
              <p
                className="button-more"
                onClick={() => {
                  setCurrentTab(HISTORY_TAB);
                }}
              >
                Xem thêm
              </p>
            </div>
          )}
        </Grid>

        <Grid item xs={12}>
          <FlowSeriesTimeline items={initialPatient?.checkinList} />
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(observer(ListCheckInBlock));
